var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('FadeTransition'),_c('FadeTransition',[(!_vm.initialized)?_c('FullLoader'):_vm._e(),(_vm.initialized)?_c('router-view'):_vm._e()],1),_c('notifications'),_c('CompanyLegalModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }